export default {
    data() {
        return {
            menu: [
                {
                    title: "Info",
                    icon: "mdi-information",
                    route: "info.index",
                },
                {
                    title: "Vehicle Logging",
                    icon: "mdi-clipboard-text",
                    route: "vehicles.logging.index",
                },
                {
                    title: "Weekly Checks",
                    icon: "mdi-calendar",
                    route: "https://forms.gle/bwSpt8a1S2v8Qu5E6",
                    external: true,
                },
                {
                    title: "Suppliers",
                    icon: "mdi-domain",
                    route: "suppliers.index",
                },
            ],
        };
    },
    mounted() {
        this.generateMenu();
        this.$root.store.sideMenuTitle = "Things";
    },

    methods: {
        generateMenu() {
            this.$root.store.sideMenu = this.menu;
        },
    },
};
